import { render, staticRenderFns } from "./shipout-request.vue?vue&type=template&id=376f880b&scoped=true"
import script from "./shipout-request.vue?vue&type=script&lang=js"
export * from "./shipout-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376f880b",
  null
  
)

export default component.exports